import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import phoneValidator from '../../foundation/js/inputValidators/phoneValidator'

const options = formFieldCommonOptions('FormInputPhoneField', {
    validatorFunction(input) {
        return phoneValidator(input)
    }
})

export default options
